import React, { useState , useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/elements/Button/Button';
import Card from '../../components/elements/Card/Card';
import DataTable from '../../components/elements/DataTable/DataTable';
import Text from '../../components/fields/Text/Text';
import ModalSettingManualActivation from '../../components/fragments/ModalSettingManualActivation';
import IconPencil from '../../components/icons/IconPencil';
import { settingStatus } from './constants';
import styles from './styles.scoped.css';
import SettingAktivasiManualFilter from '../../components/fragments/SettingAktivasiManualFilter/SettingAktivasiManualFilter';
import { fetchSettingManualActivation, submitAutoApprove } from './actions';
import queryString from 'querystring';
import { useDebounce } from '../../utils/hooks';

import ScrollToTop from '../../components/elements/ScrollToTop/ScrollToTop';
import { fetchCities, fetchDistricts, fetchProvinces, fetchVillages } from '../../components/layouts/PageBase/actions';
import { thousand } from '../../utils/format';


export default function SettingPencatatanManual (){
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [modalSetting, setModalSetting] = useState({ isOpen: false, data: {}, type: '' });

  const {
    dataSettingManualActivation: { data, meta },
    isLoadingSettingManualActivation,
    dataSubmitAutoApprove,
    isLoadingSubmitAutoApprove,
  } = useSelector((s) => s.manualLoggingActivation);

  const {
    dataDetailUser
  } = useSelector((s) => s.pageBase);

  const {
    regional =  dataDetailUser.regionalId === '' ? '' : JSON.stringify([dataDetailUser.regionalId]) ,
    provinceId = '' ,
    cityId = '',
    districtId = '',
    villageId = '',
    status = ''
  } = queryString.parse(location.search.replace('?', ''));

  const debounceParams = useDebounce(
    regional +
      provinceId +
      cityId +
      districtId+
      villageId+
      search +
      status +
    500
  );

  function getAllParams(page, type = 'search') {
    const isPage = type === 'search' && { page:  page ? page : 1 };
    let allParams = {
      regional: regional,
      provinceId:provinceId,
      cityId: cityId,
      districtId: districtId,
      villageId: villageId,
      status: status,
      search,
      ...isPage,
    };
    return allParams;
  }

  const fetchSettingManualActivationList = (params) => {
    dispatch(fetchSettingManualActivation(params));
  };

  useEffect(() => {
    if(!isLoadingSettingManualActivation && data.length <= 100){
      inputRef.current?.focus();
    }
  }, [isLoadingSettingManualActivation]);

  useEffect(() => {
    if(!modalSetting.isOpen){
      dispatch(fetchProvinces(dataDetailUser.regionalId &&
        { regional: JSON.stringify([dataDetailUser.regionalId]) }));
      dispatch(fetchCities(dataDetailUser.regionalId &&
        { regional: JSON.stringify([dataDetailUser.regionalId]) }));
      dispatch(fetchDistricts(dataDetailUser.regionalId &&
        { regional: JSON.stringify([dataDetailUser.regionalId]) }));
      dispatch(fetchVillages(dataDetailUser.regionalId &&
        { regional: JSON.stringify([dataDetailUser.regionalId]) }));
    }
  },[modalSetting]);

  useEffect(() => {
    fetchSettingManualActivationList(getAllParams(page));
  },[debounceParams, page]);

  useEffect(() => {
    const getData = setTimeout(() => {
      // Do NOT dispatch the wrapper; call it directly so it can dispatch the thunk internally
      fetchSettingManualActivationList(getAllParams());
    },2000);
    return () => clearTimeout(getData);
  },[search]);

  useEffect(() => {
    if(dataSubmitAutoApprove && !isLoadingSubmitAutoApprove){
      // Ensure modal state remains an object shape
      setModalSetting({ isOpen: false });
      setPage(1);
      fetchSettingManualActivationList(getAllParams(1));
    }
  },[dataSubmitAutoApprove, isLoadingSubmitAutoApprove]);

  const renderAction = (data) => {
    return(
      <Button
        className={styles['upload-regist-btn']}
        onClick={() => setModalSetting({ isOpen: true, data: data, type: 'one' })}
        style={'blue'}>
        <IconPencil style={{ fill: 'white' }}/> Ubah Pengaturan
      </Button>
    );
  };

  const action = dataDetailUser?.userType === 'superadmin' ? [{ heading: 'Action', value: (data) => renderAction(data) }] : [];
  const column = [
    { heading: 'Provinsi', value: 'provinceName' },
    { heading: 'Kota/Kabupaten', value: 'cityName' },
    { heading: 'Kecamatan', value: 'districtName' },
    { heading: 'Kelurahan', value: 'villageName' },
    { heading: 'Periode Aktif', value: ({ activePeriod }) => activePeriod === 0 ? 'Tanpa Batas Waktu' : `${activePeriod} Hari` },
    { heading: 'Status', value: ({ status }) => settingStatus[status] },
    ...action
  ];

  const handleSubmit = (params, areaName) => {
    dispatch(submitAutoApprove(params, areaName));
    setPage(1);
  };

  const onCloseModalSetting = () => {
    setModalSetting({ isOpen:false });
  };

  return(
    <div className={styles.mainRoot}>
      <SettingAktivasiManualFilter />
      <Card className={styles['table-filter-container']}>
        {dataDetailUser?.userType === 'superadmin' &&
        <Button
          className={styles['upload-regist-btn']}
          onClick={() => setModalSetting({ isOpen: true, type: 'bulk' })}
        >
          <IconPencil type={'setting'} />
              Pengaturan Sekaligus
        </Button>
        }
        <span>Menampilkan <strong>{thousand(meta.totalData)}</strong> data</span>
        <div className={styles['filter-wrap']}>
          <div className={styles.filters}>
            <Text
              className={styles['search-bar']}
              disabled={isLoadingSettingManualActivation}
              hideLabel
              inputProps={{
                ref: inputRef,
                placeholder: 'Cari data...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) => setSearch(e.target.value),
              }}
            />
          </div>
        </div>
      </Card>
      <br/>
      <Card className={styles.table}>
        <div className={styles['table-container']}>
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={200}
            loading={isLoadingSettingManualActivation}
            meta={meta}
            onEndReached={() => setPage(page+1)}
            onRefresh={fetchSettingManualActivationList}
            withIndex
          />
          <ModalSettingManualActivation
            data={modalSetting?.data}
            dataDetailUser={dataDetailUser}
            handleSubmit={handleSubmit}
            onClose={onCloseModalSetting}
            open={modalSetting.isOpen}
            type={modalSetting.type}
          />
          <ScrollToTop />
        </div>
      </Card>
    </div>
  );
}
